import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postSalesTax } from '../../../../actions';
import { SALES_TAX_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import SalesTaxForm from './SalesTaxForm';

const NewSalesTax = ({ breadcrumbs, dispatchpostSalesTax }) => {
  const onSubmit = (formValues) =>
    dispatchpostSalesTax({
      ...formValues,
      countryId: formValues.countryId.id
    });

  const content = <SalesTaxForm onSubmit={onSubmit} />;
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Impuesto a la Venta"
      subtitle="Crear una nuevo impuesto a la venta."
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchpostSalesTax: postSalesTax,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Impuestos a la Venta',
      href: SALES_TAX_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

NewSalesTax.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchpostSalesTax: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewSalesTax);
